import { useMemo } from "react";
import { useEmployeeNumberFilter } from "../../../Team/Actions/useFilters/useEmployeeNumberFilter";
import { useFirstNameFilter } from "../../../Team/Actions/useFilters/useFirstNameFilter";
import { useLastNameFilter } from "../../../Team/Actions/useFilters/useLastNameFilter";
import { usePayGroupFilter } from "../../../Team/Actions/useFilters/usePayGroupFilter";
import { useCalculationGroupFilter } from "../../../Team/Actions/useFilters/useCalculationGroupFilter";
import { useHomeFilters } from "../../../Home/Actions/useFilters/useHomeFilters";

export const useFiltersConfig = () => {
  const employeeNumberFilter = useEmployeeNumberFilter();
  const firstNameFilter = useFirstNameFilter();
  const lastNameFilter = useLastNameFilter();
  const payGroupFilter = usePayGroupFilter();
  const calculationGroupFilter = useCalculationGroupFilter();
  const homeFilters = useHomeFilters();
  const levelFilters = homeFilters.filter(({ id }) => id.indexOf('level') === 0);

  return useMemo(
    () => [
      employeeNumberFilter,
      firstNameFilter,
      lastNameFilter,
      ...levelFilters,
      payGroupFilter,
      calculationGroupFilter,
    ],
    [employeeNumberFilter, firstNameFilter, lastNameFilter, levelFilters, payGroupFilter, calculationGroupFilter],
  );
};
